import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-search-2-line',
    title: 'Approvisionnement stratégique & Intelligence fournisseurs',
    color: 'bg-emerald-700',
    items: [
      {
        label: 'Identification ciblée',
        detail:
          'Repérer des sources mondiales réputées et de haute qualité qui correspondent à vos exigences techniques spécifiques.',
      },
      {
        label: 'Vérification rigoureuse',
        detail:
          'Sélection en plusieurs étapes des fournisseurs potentiels pour n\'isoler que les options les plus viables, stables et collaboratives.',
      },
      {
        label: 'Pré-qualification des installations',
        detail:
          'Évaluation sur site et à distance des installations, des spécifications produits, et sollicitation d\'échantillons physiques et de dossiers techniques.',
      },
    ],
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Conformité réglementaire & Assurance qualité',
    color: 'bg-teal-700',
    items: [
      {
        label: 'Audit de conformité',
        detail:
          'Évaluation détaillée de l\'alignement des produits et des installations avec les normes réglementaires mondiales.',
      },
      {
        label: 'Représentation DMF canadienne',
        detail:
          'Agir en tant qu\'agent localisé du Drug Master File (DMF) pour le marché canadien.',
      },
      {
        label: 'Coordination des audits',
        detail:
          'Gestion transparente des audits internes des clients et des inspections réglementaires externes.',
      },
      {
        label: 'Gestion de la documentation',
        detail:
          'Collecte et vérification complètes de toute la documentation technique et de sécurité.',
      },
    ],
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Liaison exécutive & Protection des communications',
    color: 'bg-stone-700',
    items: [
      {
        label: 'Intermédiaire stratégique',
        detail:
          'Nous agissons comme votre filtre principal, vous protégeant des communications fournisseurs excessives ou « abusives » et maintenant une confidentialité totale jusqu\'à ce que vous soyez prêt à procéder.',
      },
      {
        label: 'Coordination transfrontalière',
        detail:
          'Surmonter les barrières linguistiques et gérer la logistique complexe des fuseaux horaires pour une réactivité 24h/7j.',
      },
      {
        label: 'Représentation mondiale',
        detail:
          'Représentation professionnelle des fournisseurs et coordination de réunions importantes, visites de sites internationaux et visites d\'usines.',
      },
    ],
  },
  {
    icon: 'ri-truck-line',
    title: 'Logistique & Architecture contractuelle',
    color: 'bg-emerald-800',
    items: [
      {
        label: 'Excellence en négociation',
        detail:
          'Obtenir des prix optimaux et des conditions d\'approvisionnement favorables grâce à une architecture contractuelle experte.',
      },
      {
        label: 'Logistique de bout en bout',
        detail:
          'Gestion de la planification, du transport et du dédouanement des marchandises à travers les frontières internationales.',
      },
      {
        label: 'Planification de la chaîne d\'approvisionnement',
        detail:
          'Coordination des calendriers de production et des exigences de livraison pour assurer des opérations lean et juste-à-temps.',
      },
    ],
  },
];

export default function ServicesSectionFr() {
  return (
    <section className="w-full bg-stone-50 py-20 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">Ce que nous faisons</span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-stone-800 mt-3"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Services complets d&apos;approvisionnement mondial &amp; réglementaires
          </h2>
          <p className="text-gray-500 mt-4 max-w-2xl mx-auto text-base">
            Solutions d&apos;approvisionnement complètes pour les industries pharmaceutiques et chimiques fines dans le monde entier.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {services.map((s, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden border border-stone-100 hover:-translate-y-1 transition-transform duration-200"
            >
              <div className={`${s.color} px-6 py-5 flex items-center gap-4`}>
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-md">
                  <i className={`${s.icon} text-white text-xl`} />
                </div>
                <h3 className="text-white font-bold text-base leading-tight">{s.title}</h3>
              </div>
              <div className="px-6 py-5 space-y-3">
                {s.items.map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <div className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-emerald-600 text-base" />
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      <strong className="text-stone-700 font-semibold">{item.label} :</strong>{' '}
                      {item.detail}
                    </p>
                  </div>
                ))}
                <div className="pt-2">
                  <Link
                    to="/fr/services"
                    className="inline-flex items-center gap-1 text-emerald-700 text-sm font-semibold hover:gap-2 transition-all cursor-pointer whitespace-nowrap"
                  >
                    En savoir plus <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
